module.exports = __webpack_public_path__ + "img/img-philosophy-3.42f39256.jpg";